<template>
    <div class='welcome-container'>
        <div class='inner-container'>
            <div class="center-container">
                <div class='loading'>
                    <div class='outer'></div>
                    <div class='inner'></div>
                </div>

                <div v-if="!isMobile" class='loading-text'>
                    <span>L</span>
                    <span>o</span>
                    <span>a</span>
                    <span>d</span>
                    <span>i</span>
                    <span>n</span>
                    <span>g</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "../../mixin/common";

    export default {
        name: "Loading",
        mixins:[common]
    }
</script>

<style scoped lang="less">
    .welcome-container {
        background: #00031F;
        font: 12px normal Verdana, Arial, Helvetica, sans-serif;
        height: 100%;
        width: 100%;
    }

    .inner-container {
        height: 100%;
        width: 100%;
        position: relative;
        top: 0;
    }

    .center-container{
        top: 50%;
        position: absolute;
        width: 100%;
        left: 0;
        transform: translateY(-50%);
    }

    .loading {
        margin: 0 auto;

        .outer {
            border: 5px solid rgba(0, 229, 183, 0.9);
            opacity: .9;
            border-right-color: transparent;
            border-left-color: transparent;
            width: 100px;
            height: 100px;
            margin: 0 auto;
            border-radius: 50%;
            -webkit-box-shadow: 0 0 35px rgba(0, 76, 61, 0.9);
            -moz-box-shadow: 0 0 35px rgba(0, 76, 61, 0.9);
            box-shadow: 0 0 35px rgba(0, 76, 61, 0.9);
            -webkit-animation: spin-pulse 1s linear infinite normal;
            -moz-animation: spin-pulse 1s linear infinite normal;
            -ms-animation: spin-pulse 1s linear infinite normal;
            animation: spin-pulse 1s linear infinite normal;
            -webkit-animation-delay: 0;
            -moz-animation-delay: 0;
            -o-animation-delay: 0;
            animation-delay: 0;
        }

        .inner {
            border: 5px solid rgba(0, 229, 183, 0.9);
            opacity: .9;
            border-left-color: transparent;
            border-right-color: transparent;
            border-radius: 50%;
            -webkit-box-shadow: 0 0 15px rgba(0, 76, 61, 0.9);
            -moz-box-shadow: 0 0 15px rgba(0, 76, 61, 0.9);
            box-shadow: 0 0 15px rgba(0, 76, 61, 0.9);
            width: 60px;
            height: 60px;
            position: relative;
            top: -80px;
            left: 1px;
            margin: 0 auto;
            -webkit-animation: spin-right 1s linear infinite normal;
            -moz-animation: spin-right 1s linear infinite normal;
            -ms-animation: spin-right 1s linear infinite normal;
            animation: spin-right 1s linear infinite normal;
        }
    }


    .loading-text {
        text-align: center;
        text-transform: uppercase;
        font-family: 'Nunito', sans-serif;
        font-size: 4.6875em;
        color: transparent;
        letter-spacing: 0.01em;

        span {
            text-shadow: 0 0 2px rgba(22, 22, 22, 0.9), 0 15px 25px rgba(0, 0, 0, 0.3), 0 -2px 3px rgba(0, 0, 0, 0.1), 0 -5px 10px rgba(22, 22, 22, 0.5), 0 5px 10px rgba(0, 0, 0, 0.3), 0 3px 4px rgba(22, 22, 22, 0.2), 0 0 20px rgba(22, 22, 22, 0.45);
            -webkit-animation: letters 0.85s ease-in-out infinite alternate;
            -moz-animation: letters 0.85s ease-in-out infinite alternate;
            -ms-animation: letters 0.85s ease-in-out infinite alternate;
            animation: letters 0.85s ease-in-out infinite alternate;
        }

        span:nth-child(2) {
            -webkit-animation-delay: 0.15s;
            -moz-animation-delay: 0.15s;
            -o-animation-delay: 0.15s;
            animation-delay: 0.15s;
        }

        span:nth-child(3) {
            -webkit-animation-delay: 0.3s;
            -moz-animation-delay: 0.3s;
            -o-animation-delay: 0.3s;
            animation-delay: 0.3s;
        }

        span:nth-child(4) {
            -webkit-animation-delay: 0.45s;
            -moz-animation-delay: 0.45s;
            -o-animation-delay: 0.45s;
            animation-delay: 0.45s;
        }

        span:nth-child(5) {
            -webkit-animation-delay: 0.6s;
            -moz-animation-delay: 0.6s;
            -o-animation-delay: 0.6s;
            animation-delay: 0.6s;
        }

        span:nth-child(6) {
            -webkit-animation-delay: 0.75s;
            -moz-animation-delay: 0.75s;
            -o-animation-delay: 0.75s;
            animation-delay: 0.75s;
        }

        span:nth-child(7) {
            -webkit-animation-delay: 0.9s;
            -moz-animation-delay: 0.9s;
            -o-animation-delay: 0.9s;
            animation-delay: 0.9s;
        }
    }


    @keyframes spin-right {
        from {
            transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            transform: rotate(180deg);
            opacity: 1.0;
        }
        to {
            transform: rotate(360deg);
            opacity: 0.2;
        }
    }

    @-moz-keyframes spin-right {
        from {
            -moz-transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            -moz-transform: rotate(180deg);
            opacity: 1.0;
        }
        to {
            -moz-transform: rotate(360deg);
            opacity: 0.2;
        }
    }

    @-webkit-keyframes spin-right {
        from {
            -webkit-transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            -webkit-transform: rotate(180deg);
            opacity: 1.0;
        }
        to {
            -webkit-transform: rotate(360deg);
            opacity: 0.2;
        }
    }

    @keyframes spin-left {
        from {
            transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            transform: rotate(-180deg);
            opacity: 1.0;
        }
        to {
            transform: rotate(-360deg);
            opacity: 0.2;
        }
    }

    @-moz-keyframes spin-left {
        from {
            -moz-transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            -moz-transform: rotate(-180deg);
            opacity: 1.0;
        }
        to {
            -moz-transform: rotate(-360deg);
            opacity: 0.2;
        }
    }

    @-webkit-keyframes spin-left {
        from {
            -webkit-transform: rotate(0deg);
            opacity: 0.2;
        }
        50% {
            -webkit-transform: rotate(-180deg);
            opacity: 1.0;
        }
        to {
            -webkit-transform: rotate(-360deg);
            opacity: 0.2;
        }
    }

    @keyframes spin-pulse {
        from {
            transform: rotate(160deg);
            opacity: 0;
            box-shadow: 0 0 1px rgba(0, 61, 76, 0.9);
        }
        50% {
            transform: rotate(145deg);
            opacity: 1;
        }
        to {
            transform: rotate(-320deg);
            opacity: 0;
        }
    }

    @-moz-keyframes spin-pulse {
        from {
            -moz-transform: rotate(160deg);
            opacity: 0;
            box-shadow: 0 0 1px rgba(0, 61, 76, 0.9);
        }
        50% {
            -moz-transform: rotate(145deg);
            opacity: 1;
        }
        to {
            -moz-transform: rotate(-320deg);
            opacity: 0;
        }
    }

    @-webkit-keyframes spin-pulse {
        from {
            -webkit-transform: rotate(160deg);
            opacity: 0;
            box-shadow: 0 0 1px rgba(0, 61, 76, 0.9);
        }
        50% {
            -webkit-transform: rotate(145deg);
            opacity: 1;
        }
        to {
            -webkit-transform: rotate(-320deg);
            opacity: 0;
        }
    }

    @keyframes pulse {
        from {
            transform: scale(1.2);
            opacity: 1;
        }
        to {
            transform: scale(0.7);
            opacity: 0.1;
        }
    }

    @-moz-keyframes pulse {
        from {
            -moz-transform: scale(1.2);
            opacity: 1;
        }
        to {
            -moz-transform: scale(0.7);
            opacity: 0.1;
        }
    }

    @-webkit-keyframes pulse {
        from {
            -webkit-transform: scale(1.2);
            opacity: 1;
        }
        to {
            -webkit-transform: scale(0.7);
            opacity: 0.1;
        }
    }


    @keyframes letters {
        to {
            text-shadow: 0 0 2px rgba(204, 208, 212, 0.2), 0 0 3px rgba(0, 0, 0, 0.02), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(255, 255, 255, 0), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(255, 255, 255, 0), 0 0 0 rgba(255, 255, 255, 0);
        }
    }

    @-moz-keyframes letters {
        to {
            text-shadow: 0 0 2px rgba(204, 208, 212, 0.2), 0 0 3px rgba(0, 0, 0, 0.02), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(255, 255, 255, 0), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(255, 255, 255, 0), 0 0 0 rgba(255, 255, 255, 0);
        }
    }

    @-webkit-keyframes letters {
        to {
            text-shadow: 0 0 2px rgba(22, 22, 22, 0.2), 0 0 3px rgba(0, 0, 0, 0.02), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0);
        }
    }

</style>
